import HeroCardTile4up from './HeroCardTile4up';

export * from './types';

export default HeroCardTile4up;
